"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var updateCampusGroup = function (id, group) {
    return (0, service_1.getService)()
        .patch("/managed_campus/device_groups/".concat(id), group)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = updateCampusGroup;
